import React, {FC} from 'react'

type PropsImgUpload = {
  field: string,
  value: string[],
}
const FileUploadForm: FC<PropsImgUpload> = ({field, value}) => {

  const links = value.map((i) => {

    const route = i,
      name = i.split('/').pop()
    return {route, name}
  })
  return (
    <>
      <div className='row mb-7'>
        <label className='col-lg-4 fw-bold text-muted text-capitalize'>{field}</label>
        <div className='col-lg-8 fv-row'>

          {
            links.map((link, i) => (
              <div className="py-1" key={i}>
                <a className="text-gray-800 text-hover-primary fs-6 fw-bold"
                   href={link.route}
                   target="_blank"
                >
                  <span className='menu-bullet me-3'>
                      <span className='bullet bullet-dot'/>
                  </span>
                  {link.name}
                </a>

              </div>
            ))
          }

        </div>
      </div>
    </>
  )
}

export {FileUploadForm}